import { AccountingPeriod } from "@/types/enums";

export const getBegend = (
  tagKoLabel: string | null | undefined,
): AccountingPeriod => {
  if (tagKoLabel?.startsWith("기초")) {
    return AccountingPeriod.BEGIN;
  } else if (tagKoLabel?.startsWith("기말")) {
    return AccountingPeriod.END;
  } else {
    return AccountingPeriod.NONE;
  }
};
